import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    claimPopup: false,
}

export const PopupSlice = createSlice({
    name: "popup",
    initialState,
    reducers: {
        toggleClaimPopup: (state, action) => {
            state.claimPopup = action.payload;
        },
    },
});

export const { toggleClaimPopup } = PopupSlice.actions;

export default PopupSlice.reducer;